import React, { useEffect, useRef } from 'react';

// Registers the <trix-editor> custom element. Kept here rather than in a pack so this component
// can be rendered anywhere.
import 'trix';
import 'trix/dist/trix.css';

type TrixEditorProps = {
  id: string;
  initialValue?: string;
  name: string;
  onChange?: (value: string) => void;
};

export default function TrixEditor({ id, initialValue, name, onChange }: TrixEditorProps) {
  const trixInput = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = trixInput.current;
    if (!el) return;
    const fileHandler = (e: Event) => e.preventDefault();
    el.addEventListener('trix-file-accept', fileHandler);

    return () => el.removeEventListener('trix-file-accept', fileHandler);
  }, []);

  useEffect(() => {
    const el = trixInput.current;
    if (!el || !onChange) return;
    const changeHandler = (e: Event) => onChange((e.target as HTMLElement).innerHTML);
    el.addEventListener('trix-change', changeHandler);

    return () => el.removeEventListener('trix-change', changeHandler);
  }, [onChange]);

  return (
    <>
      <input
        id={id}
        name={name}
        type="hidden"
        value={initialValue || ''}
      />
      <trix-editor
        class="trix-content"
        id={`editor-${id}`}
        input={id}
        ref={trixInput}
      />
    </>
  );
}
